import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiCalendar, FiExternalLink, FiMessageSquare } from 'react-icons/fi';
import { format } from 'date-fns';

// Date formatting helper
function formatDisplayDate(value) {
  if (!value) return "Not set";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const day = String(date.getDate()).padStart(2, "0");
  const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  const weekdays = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  return `${day}-${months[date.getMonth()]}-${date.getFullYear()}, ${weekdays[date.getDay()]}`;
}

export default function LeadCard({ lead, onClick }) {
  return (
    <div 
      onClick={onClick} 
      className="bg-surface border border-border rounded-xl p-5 cursor-pointer shadow-card hover:shadow-premium transition-premium active:scale-[0.98] relative overflow-hidden group"
    >
      <div className="flex justify-between items-start mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-slate-50 border border-border rounded-lg flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors">
            <span className="font-semibold text-sm">{(lead.name || 'A').charAt(0).toUpperCase()}</span>
          </div>
          <div>
            <h4 className="font-semibold text-ink text-sm leading-none">{lead.name || 'Anonymous'}</h4>
            <div className="flex items-center gap-2 mt-1.5">
              <SafeIcon icon={FiCalendar} className="text-slate-400 text-xs" />
              <span className="text-xs text-muted font-medium">
                {formatDisplayDate(lead.created_at)}
              </span>
            </div>
          </div>
        </div>
        <div className="w-7 h-7 rounded-full bg-slate-50 flex items-center justify-center text-slate-400 group-hover:text-primary transition-colors">
          <SafeIcon icon={FiExternalLink} className="text-sm" />
        </div>
      </div>

      <div className="space-y-3">
        <div className="flex flex-col gap-1">
          <span className="text-xs text-muted font-medium">Contact</span>
          <span className="text-sm font-medium text-ink truncate">{lead.email || 'Private Email'}</span>
        </div>
        <div className="bg-slate-50 rounded-lg p-3 border border-border relative">
          <div className="absolute top-2 right-2 opacity-10">
            <SafeIcon icon={FiMessageSquare} className="text-sm" />
          </div>
          <p className="text-sm text-slate-600 italic line-clamp-2 leading-relaxed font-medium">
            "{lead.message || 'No enquiry message provided'}"
          </p>
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between">
        <span className="px-2 py-1 bg-primary/5 text-primary rounded-md text-xs font-medium uppercase tracking-wide">
          {lead.utm_source || 'Direct'}
        </span>
        <div className="flex gap-1">
          <div className={`w-1.5 h-1.5 rounded-full ${lead.business_email_sent ? 'bg-success' : 'bg-slate-200'}`}></div>
          <div className={`w-1.5 h-1.5 rounded-full ${lead.sms_sent ? 'bg-success' : 'bg-slate-200'}`}></div>
        </div>
      </div>
    </div>
  );
}